import { ChangeDetectionStrategy, Component } from '@angular/core';
import { DatePipe, registerLocaleData } from '@angular/common';
import { AuthenticationService } from '@src/app/_services/authentication.service';
import { UntilDestroy } from '@ngneat/until-destroy';

import moment from 'moment';
import localeCs from '@angular/common/locales/cs';
import { User } from '@src/app/_models/user/user';

moment.updateLocale('cs', { workingWeekdays: [1, 2, 3, 4, 5] });
registerLocaleData(localeCs);

@UntilDestroy()
@Component({
    selector: 'app-stats-card',
    templateUrl: './stats-card.component.html',
    styleUrls: ['./stats-card.component.scss'],
    providers: [DatePipe],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StatsCardComponent {
    currentUser: User | null;

    constructor(private readonly authenticationService: AuthenticationService) {
        this.currentUser = this.authenticationService.currentUserValue;
    }
}
